import React from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Search from "./Search";
function App() {
  return (
    <>
      <Search />
    </>
  );
}
export default App;
